module.exports = __webpack_public_path__ + "./assets/flags/brazil.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bra@2x.png
// module id = 68
// module chunks = 0 1